import { render, staticRenderFns } from "./CampaignPromotionReview.vue?vue&type=template&id=860463e8&"
import script from "./CampaignPromotionReview.vue?vue&type=script&lang=js&"
export * from "./CampaignPromotionReview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPromotionReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CampaignPromotionReview.vue"
export default component.exports